module.exports = __webpack_public_path__ + "static/media/ic-close.04086d2e.svg";